<template>
  <auth-template>
    <template v-slot:main>

      <div class="form" v-if="!success_result">
        <div class="head">
          <h3 class="title">Регистрация</h3>
          <p class="sub_title_text">Введите корректные данные для регистрации на сайте</p>
        </div>

        <div class="body">

          <form>
            <standart-filed
                id="email" title="Электронная почта" type="text" placeholder="Введите почту"
                :value="form.email" @updated="form.email = $event"
                :error-text="errors.email"
            >
            </standart-filed>

            <standart-filed
              id="fio" title="ФИО" type="text" placeholder="Введите ФИО"
              :value="form.fio" @updated="form.fio = $event"
              :error-text="errors.fio"
            >
            </standart-filed>

            <standart-filed
              id="phone" title="Телефон" type="text" placeholder="+7 (900) 000-00-00"
              :value="form.phone" @updated="form.phone = $event"
              :error-text="errors.phone"
              mask="+7 (###) ###-##-##"
            >
            </standart-filed>

            <standart-filed
              id="password" title="Пароль" type="password" placeholder="Введите пароль"
              :value="form.password" @updated="form.password = $event"
              :error-text="errors.password"
            >
            </standart-filed>
          </form>


          <div class="confirm">
            <standart-checkbox
                id="privacy_policy"
                :checked="form.conf_privacy_policy"
                @change="form.conf_privacy_policy = $event"
                :error-text="errors.conf_privacy_policy"
            >
              <template v-slot:text_content>
                Я соглашаюсь с <span class="bl" @click="$router.push({name: 'privacy_policy'});">политикой конфиденциальности</span>
              </template>
            </standart-checkbox>
            <standart-checkbox
                id="public_offer"
                :checked="form.conf_public_offer"
                @change="form.conf_public_offer = $event"
                :error-text="errors.conf_public_offer"
            >
              <template v-slot:text_content>
                Я принимаю <span class="bl" @click="$router.push({name: 'offer'});">условия публичной оферты</span>
              </template>
            </standart-checkbox>
          </div>

          <div class="share_error_b" v-show="error != ''">
            <p v-html="error"></p>
          </div>


          <div class="bottom">
            <standart-button @click="registration()" style_type="prime" text="Зарегистрироваться"></standart-button>
            <p>Уже зарегистрированы? <span
                @click="$router.push({name:'login'})" class="bl">Войти в аккаунт</span>
            </p>
          </div>

        </div>
      </div>

      <div class="form success" v-if="success_result">
        <div class="head">
          <h3 class="title">Вы успешно зарегистрированы!</h3>
          <p class="sub_title_text"></p>
        </div>

        <div class="body">

          <div class="bottom">
            <standart-button @click="$router.push({name:'login'})" style_type="prime" text="Войти в личный кабинет"></standart-button>
          </div>

        </div>
      </div>

    </template>
  </auth-template>
</template>

<script>
// @ is an alias to /src
import AuthTemplate from '@/components/AuthTemplate.vue';
import StandartFiled from "@/components/share/StandartField";
import StandartCheckbox from "@/components/share/StandartCheckbox";
import StandartButton from "@/components/share/StandartButton";
import axios from "axios";


export default {
  name: 'RegistrationView',
  components: {
    StandartButton,
    StandartCheckbox,
    StandartFiled,
    AuthTemplate,
  },
  data() {
    return{
      form : {
        email : "",
        fio : "",
        phone : "",
        password: "",
        conf_privacy_policy: false,
        conf_public_offer: false,
      },
      errors: {
        email : "",
        fio : "",
        phone : "",
        password: "",
        conf_privacy_policy: "",
        conf_public_offer: "",
      },
      error : "",
      success_result: false,
    }
  },
  methods : {
    registration: async function() {

      console.log(this.form);

      if (!this.validate()) {
        return;
      }

      try {

        const bodyFormData = new FormData;

        for(let field in this.form) {
          bodyFormData.append(field, this.form[field]);
        }

        let res = await axios.post(window.api_url + 'auth/register?api=y', bodyFormData);

        if (res.data.status === "fail") {
          this.error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          this.success_result = true;
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }

    },
    validate: function() {
      for(let field in this.form) {this.errors[field] = "";}
      this.error = "";

      let validation = true;

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      for(let field in this.form) {

        if(this.form[field] == "") {
          this.errors[field] = "Обязательное поле";
          validation = false;
        }

        if(field == "email"){
          if(!EMAIL_REGEXP.test(this.form[field]) && this.form[field] != "") {
            this.errors[field] = "Электронная почта введена некорректно";
            validation = false;
          }
        }

        if(field == "phone"){
          if(this.form[field]?.replaceAll(/\D*/gm, '').length <= 10 && this.form[field] != "") {
            this.errors[field] = "Телефон введен некорректно";
            validation = false;
          }
        }

      }

      return validation;
    }
  }
}
</script>


<style scoped>

.standart_field.email {
  margin-bottom: 18px;
}

.standart_field.fio {
  margin-bottom: 18px;
}

.standart_field.phone {
  margin-bottom: 18px;
}

.standart_field.password {
  margin-bottom: 18px;
}

.share_error_b p {
  color: var(--Red, #FA4B61);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
}

.confirm {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.bottom {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.bottom p {
  color: var(--Gray, #656565);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0px;
  margin: 0px;
  text-align: center;
}

.bl {
  color: var(--Blue, #1B78BC);
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}


/*MOBILE*/
@media (max-width: 1250px)
{
  .standart_field.fio {
    margin-bottom: 14px;
  }

  .standart_field.phone {
    margin-bottom: 14px;
  }

  .standart_field.password {
    margin-bottom: 14px;
  }

  .bottom {
    gap: 12px;
  }

  .confirm {
    margin-bottom: 20px;
  }
}
</style>
